import React from "react";
import { Box } from "@mui/material";
import logo from "../assets/investteklogo.png";

const Navbar = () => {
  return (
    <div
      style={{
        alignItems: "center",
        height: "34px",
        backgroundColor: "#223D6C",
        color: "white",
        padding: "15px",
      }}
    >
      <Box>
        <img src={logo} alt="Logo" width={"100px"} />
      </Box>
    </div>
  );
};

export default Navbar;
